import React, { useEffect, useCallback } from "react";
import { useRouter } from "next/router";
import { Box } from "@bca/ui-library";
import addFiltersToPageUrl from "./addFiltersToPageUrl";
import SelectGroup from "./SelectGroup";

let timer;

const VehicleAgeFilter = ({
  appliedCheckboxes,
  setAppliedCheckboxes,
  setSelectedVehicles,
  rangeSubfilters,
  searchResultsLoading,
}) => {
  const router = useRouter();

  const debounceUrlUpdate = useCallback(() => {
    clearTimeout(timer);

    timer = setTimeout(() => {
      const newUrl = addFiltersToPageUrl("bq", appliedCheckboxes);
      const currentPageUrl = new URL(window.location.href);
      if (newUrl.href === currentPageUrl.href) {
        return;
      }
      newUrl.searchParams.delete("page");
      newUrl.searchParams.delete("vrm");
      router.push(newUrl.href, newUrl.href, { shallow: true });
    }, 1000);
  }, [appliedCheckboxes, router]);

  const stringifiedFilters = JSON.stringify(appliedCheckboxes);
  useEffect(() => {
    debounceUrlUpdate();
  }, [stringifiedFilters, debounceUrlUpdate]);

  const onSelectChange = (filterKey, categoryKey) => {
    setSelectedVehicles([]);
    let newState = null;
    const filterAlreadyApplied = appliedCheckboxes.find(
      (item) => item.categoryKey.toLowerCase() === categoryKey.toLowerCase()
    );

    newState = [
      ...appliedCheckboxes.filter((item) => item !== filterAlreadyApplied),
      {
        filterKey: filterKey,
        categoryKey,
        groupedBy: "",
        parentFilterKey: "",
      },
    ];

    setAppliedCheckboxes([...newState]);
  };

  return (
    <Box>
      {rangeSubfilters && (
        <SelectGroup
          rangeSubfilters={rangeSubfilters}
          categoryKey="DateRegistered"
          onChange={onSelectChange}
          searchResultsLoading={searchResultsLoading}
          appliedCheckboxes={appliedCheckboxes}
          labels={["From", "To"]}
        ></SelectGroup>
      )}
    </Box>
  );
};

export default VehicleAgeFilter;
